export enum ContactPreference {
  EmailAndPhone,
  Email,
  Phone
}
